import { Store } from '@reduxjs/toolkit';
import { AxiosInstance } from 'axios';

function setToken(httpClient: AxiosInstance, store: Store): void {
  httpClient.interceptors.request.use(config => {
    const { auth } = store.getState();
    if (auth.authorization.accessToken && config.headers) {
      config.headers.Authorization = `Bearer ${auth.authorization.accessToken}`;
    }
    return config;
  });
}

export default setToken;
